import { FlowFilterConfig } from "../filter-config/_filterConfigId_";

export const RoutePutMerchflows_merchflowId_Filters = "/merchflows/:merchflowId/filters";

export interface PayloadPutMerchflows_merchflowId_Filters {
  flowId: number;
  filter_config: FilterConfigPayloadType;
}

export type FilterConfigPayloadType = Omit<FilterConfigType, "stores"> & {
  stores: FilterConfigPayloadStore[];
};

export type FilterConfigPayloadStore = FilterConfigStore;

export type ResponsePutMerchflows_merchflowId_Filters = FlowFilterConfig;

export interface FilterConfigType {
  baySizes: number[];
  clusters: string[];
  fixtures: {
    section_width: number[];
    section_height: number[];
  };
  states: string[];
  stores: FilterConfigStore[];
  cdt?: unknown;
  hierachy?: unknown;
}

export interface FilterConfigStore {
  bay_size: number;
  state: string;
  section_height: number;
  section_width: number;
  cluster: string;
  retailer_category_code: string;
  category_code: string;
  store: string;
  template_id: string;
}
